import { useEffect, useState } from 'react';
import { useBreakpoint } from '../../../../../../../../UILibrary';

export function useFileSection() {
  const [isSelectingFiles, setIsSelectingFiles] = useState(false);
  const [checkedFileMap, setCheckedFileMap] = useState<Record<number, boolean>>(
    {},
  );
  const { isSmall } = useBreakpoint();

  const onCancelSelectFiles = () => {
    setCheckedFileMap({});
    setIsSelectingFiles(false);
  };

  useEffect(() => {
    // When the screen is resized to small, multi-select is not present so should be reset
    if (isSmall) {
      onCancelSelectFiles();
    }
  }, [isSmall]);

  return {
    isSelectingFiles,
    checkedFileMap,
    setIsSelectingFiles,
    setCheckedFileMap,
    onCancelSelectFiles,
  };
}
